import React from "react";
import { SVGIconProps } from "./../type";

export default function BarChart({ className, style }: SVGIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      className={className}
      style={style}
      version="1.1"
      viewBox="0 0 485.019 485.019"
      xmlSpace="preserve"
    >
      <path d="M324.718 66.719c6.7-14.4 13.4-28.7 20.5-44-78-32.8-154.1-31.2-226.9 12.1-70.3 41.9-108.5 105.4-118.3 187.3 16.7 1.5 32.5 2.8 48.3 4.2 8.6-123.7 145.3-218.6 276.4-159.6zM481.518 201.219c-15.7 2.7-31.3 5.5-47.6 8.3 8.4 56.7-3.2 107.7-37.9 152.4-34.4 44.5-80.4 69-136.8 75.2 1.4 16 2.7 31.6 4.1 47.2 118-4.2 244.4-122.7 218.2-283.1zM47.518 260.319c-15 1.3-30.6 2.6-46.2 4 3.6 98.9 89.9 210.1 219.9 220.7 1.4-16 2.8-31.7 4.1-46.9-101.6-17-160.6-75.9-177.8-177.8zM396.318 124.819c12.1 15.7 21.5 33 28.8 52 15.1-5.5 30-10.9 45.6-16.6-18-47.9-47.4-86-89-115.9-9.3 13.2-18.4 26.2-27.8 39.7 16 11.8 30.3 25.1 42.4 40.8z"></path>
      <path d="M302.218 177.819c-4.4 0-7.9 3.5-7.9 7.9v156.3c0 4.4 3.5 7.9 7.9 7.9h54.1c4.4 0 7.9-3.5 7.9-7.9v-156.3c0-4.4-3.5-7.9-7.9-7.9h-54.1zm46.2 156.3h-38.3v-140.4h38.3v140.4zM128.718 219.319c-4.4 0-7.9 3.5-7.9 7.9v114.8c0 4.4 3.5 7.9 7.9 7.9h54.1c4.4 0 7.9-3.5 7.9-7.9v-114.8c0-4.4-3.5-7.9-7.9-7.9h-54.1zm7.9 114.8v-12.3l12.3 12.3h-12.3zm24.8 0l-24.8-24.8v-12.5l37.4 37.4h-12.6v-.1zm13.5-11.6l-38.3-38.3v-12.5l38.3 38.3v12.5zm0-25l-38.3-38.3v-12.5l38.3 38.3v12.5zm0-25l-37.3-37.3h12.5l24.8 24.8v12.5zm0-25.1l-12.3-12.3h12.3v12.3zM215.418 114.319c-4.4 0-7.9 3.5-7.9 7.9v219.8c0 4.4 3.5 7.9 7.9 7.9h54.1c4.4 0 7.9-3.5 7.9-7.9v-219.8c0-4.4-3.5-7.9-7.9-7.9h-54.1z"></path>
    </svg>
  );
}
